const extractFromData = (form, token) => {
  const formData = {
    email: form.email,
    grecaptchaToken: token,
    formName: form.formName,
    name: form.name,
    company: form.company,
    salutation: form.salutation,
    position: form.position,
    privacy: form.privacy,
    gppFocus: form.gppFocus,
    gppNewsletter: form.gppNewsletter,
    telephone: form.telephone,
    title: form.title,
    departmentEmail: form.departmentEmail,
    department: form.department,
  };

  return formData;
};

module.exports = {
  extractFromData,
};
